(function (root) {
  var SCOPE_RULES = [
    { key: 'ruffruff', patterns: ['ruffruff-pre-order'] },
    { key: 'promolayer', patterns: ['promolayer_loader', 'modules.promolayer.io', 'displayscdn.promolayer'] },
    { key: 'comvey', patterns: ['comvey-popup', 'comvey-for-sea-room-lynn', 'flow-of-service-usage'] },
    { key: 'minmaxify', patterns: ['limits.minmaxify.com'] },
    { key: 'bis', patterns: ['backinstock.useamp.com', '/back-in-stock-', 'preorder-product-page-updater'] },
    { key: 'delivery', patterns: ['cart-delivery-datetime'] }
  ];

  function parseConfig(raw) {
    if (!raw) return {};
    try {
      return JSON.parse(raw) || {};
    } catch (error) {
      return {};
    }
  }

  function matchesAny(src, patterns) {
    if (!src) return false;
    src = String(src);
    for (var i = 0; i < patterns.length; i++) {
      if (src.indexOf(patterns[i]) !== -1) return true;
    }
    return false;
  }

  function isAllowed(allow, key) {
    return !!(allow && allow[key]);
  }

  function shouldDrop(src, allow, designMode) {
    if (designMode) return false;
    if (!src) return false;
    src = String(src);
    for (var i = 0; i < SCOPE_RULES.length; i++) {
      var rule = SCOPE_RULES[i];
      if (matchesAny(src, rule.patterns) && !isAllowed(allow, rule.key)) {
        return true;
      }
    }
    return false;
  }

  function nodeUrl(node) {
    if (!node || node.nodeType !== 1) return '';
    var tag = node.tagName;
    if (tag === 'SCRIPT') {
      return node.src || node.getAttribute('src') || '';
    }
    if (tag === 'LINK') {
      return node.href || node.getAttribute('href') || '';
    }
    if (tag === 'IMG') {
      return node.src || node.getAttribute('src') || '';
    }
    return '';
  }

  function isYappliSrc(src) {
    return !!src && String(src).indexOf('yappli.io') !== -1;
  }

  function isOwnYappli(node) {
    return !!(node && node.getAttribute && node.getAttribute('data-srl-yappli'));
  }

  function shouldInterceptYappli(node) {
    return isYappliSrc(nodeUrl(node)) && !isOwnYappli(node);
  }

  function createController(config) {
    config = config || {};
    var pageType = config.pageType;
    var flushSoon = pageType === 'cart';
    var yappliSoon = pageType === 'customers/account';
    var loadYappli = !!config.loadYappli;
    var designMode = !!config.designMode;
    var allow = config.allow || {};
    var HARD_FLUSH_MS = 8000;
    var YAPPLI_POLL_MS = 100;
    var YAPPLI_TIMEOUT_MS = 10000;
    var deferPatterns = [
      'prime-review/scripts/',
      'productreviews.shopifycdn.com'
    ];

    function matches(src) {
      return matchesAny(src, deferPatterns);
    }

    function dropSrc(src) {
      return shouldDrop(src, allow, designMode);
    }

    return {
      pageType: pageType,
      flushSoon: flushSoon,
      yappliSoon: yappliSoon,
      loadYappli: loadYappli,
      designMode: designMode,
      allow: allow,
      HARD_FLUSH_MS: HARD_FLUSH_MS,
      YAPPLI_POLL_MS: YAPPLI_POLL_MS,
      YAPPLI_TIMEOUT_MS: YAPPLI_TIMEOUT_MS,
      matches: matches,
      shouldDrop: dropSrc
    };
  }

  function neutralize(node, dropSrc) {
    if (!node || node.nodeType !== 1) return;
    if (dropSrc(nodeUrl(node))) {
      if (node.parentNode) {
        try { node.parentNode.removeChild(node); } catch (err) {}
      } else if (node.tagName === 'SCRIPT') {
        node.type = 'text/plain';
        try { node.removeAttribute('src'); } catch (err) {}
      } else {
        try { node.removeAttribute('href'); } catch (err) {}
        try { node.removeAttribute('src'); } catch (err) {}
      }
      return;
    }

    if (!node.querySelectorAll) return;
    var nested = node.querySelectorAll('script[src],link[href],img[src]');
    for (var i = 0; i < nested.length; i++) {
      neutralize(nested[i], dropSrc);
    }
  }

  function boot(controller) {
    var pending = [];
    var flushed = false;
    var nativeInsertBefore = Element.prototype.insertBefore;
    var nativeAppendChild = Element.prototype.appendChild;

    function enqueue(apply) {
      if (flushed) {
        apply();
        return;
      }
      pending.push(apply);
    }

    function patchYappliOnly() {
      Element.prototype.insertBefore = function (node, child) {
        var parent = this;
        if (shouldInterceptYappli(node)) return node;
        return nativeInsertBefore.call(parent, node, child);
      };
      Element.prototype.appendChild = function (node) {
        var parent = this;
        if (shouldInterceptYappli(node)) return node;
        return nativeAppendChild.call(parent, node);
      };
    }

    function flush() {
      if (flushed) return;
      flushed = true;
      patchYappliOnly();
      for (var i = 0; i < pending.length; i++) {
        try { pending[i](); } catch (err) {}
      }
      pending = [];
    }

    function scheduleFlush() {
      var run = function () {
        if (controller.flushSoon) {
          flush();
          return;
        }
        if ('requestIdleCallback' in window) {
          requestIdleCallback(flush, { timeout: 2500 });
        } else {
          setTimeout(flush, 1);
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run);
      }

      setTimeout(flush, controller.HARD_FLUSH_MS);
    }

    function intercept(node, applyNative) {
      if (shouldInterceptYappli(node)) return node;
      var src = nodeUrl(node);
      if (src && controller.shouldDrop(src)) return node;
      if (src && controller.matches(src)) {
        enqueue(applyNative);
        return node;
      }
      return applyNative();
    }

    Element.prototype.insertBefore = function (node, child) {
      var parent = this;
      return intercept(node, function () {
        return nativeInsertBefore.call(parent, node, child);
      });
    };

    Element.prototype.appendChild = function (node) {
      var parent = this;
      return intercept(node, function () {
        return nativeAppendChild.call(parent, node);
      });
    };

    if (typeof MutationObserver === 'function' && document.documentElement) {
      var observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            neutralize(added[j], controller.shouldDrop);
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    var yappliSettled = false;

    function settleYappli(ok) {
      if (yappliSettled) return;
      yappliSettled = true;
      document.dispatchEvent(new CustomEvent(ok ? 'srl:yappli-ready' : 'srl:yappli-failed'));
    }

    function waitForYappli() {
      var started = Date.now();
      (function poll() {
        if (window.Yappli) {
          settleYappli(true);
          return;
        }
        if (Date.now() - started >= controller.YAPPLI_TIMEOUT_MS) {
          settleYappli(false);
          return;
        }
        setTimeout(poll, controller.YAPPLI_POLL_MS);
      })();
    }

    function injectYappli() {
      if (window.Yappli) {
        settleYappli(true);
        return;
      }

      if (document.querySelector('script[data-srl-yappli],script[src*="yappli.io"]')) {
        waitForYappli();
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://yappli.io/v1/sdk.js';
      script.async = true;
      script.setAttribute('data-srl-yappli', '1');
      script.onload = waitForYappli;
      script.onerror = function () {
        settleYappli(false);
      };
      document.head.appendChild(script);
    }

    function scheduleYappli() {
      var run = function () {
        if (controller.yappliSoon) {
          injectYappli();
          return;
        }
        if ('requestIdleCallback' in window) {
          requestIdleCallback(injectYappli, { timeout: 3000 });
        } else {
          setTimeout(injectYappli, 1);
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run);
      }
    }

    scheduleFlush();
    if (controller.loadYappli) scheduleYappli();
  }

  var api = {
    SCOPE_RULES: SCOPE_RULES,
    parseConfig: parseConfig,
    matchesAny: matchesAny,
    shouldDrop: shouldDrop,
    nodeUrl: nodeUrl,
    isYappliSrc: isYappliSrc,
    isOwnYappli: isOwnYappli,
    shouldInterceptYappli: shouldInterceptYappli,
    createController: createController
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  var config = {};
  var configEl = document.getElementById('srl-deferred-third-party-config');
  if (configEl) {
    config = parseConfig(configEl.textContent);
  }
  boot(createController(config));
})(typeof globalThis !== 'undefined' ? globalThis : this);
